import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialRetail() {
  return <IndustryDetailPage industry="retail" />;
}

export default TestimonialRetail;
